import { render, staticRenderFns } from "./CallAside.vue?vue&type=template&id=c522f670"
import script from "./CallAside.vue?vue&type=script&lang=js"
export * from "./CallAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports